export enum FILE_VALIDATION_ERRORS {
  FILE_PROCESSING = 'FILE_PROCESSING',
  FILE_SIZE = 'FILE_SIZE',
  FILE_TYPE = 'FILE_TYPE',
  NO_FILE = 'NO_FILE',
}

export enum LINKS {
  FIRST = 'first',
  NEXT = 'next',
}

export const SOCIAL_PLATFORMS = {
  FACEBOOK: 'fb',
  YOUTUBE: 'yt',
} as const;

export const PRIVACY_OPTIONS = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  UNLISTED: 'unlisted',
} as const;
